module.exports = __webpack_public_path__ + "static/img/e-commerce.4511d123.svg";